import React from 'react';

import { API_URLS } from '../../../../../helpers/api/API_URLS';
import { basicGET } from '../../../../../helpers/api/fetchParams';

import { InputRow } from '../../../../../helpers/uiComponents/InputRow';
import { ActionTabs } from '../../../../../helpers/uiComponents/ActionTabs';
import { showMessage, hideMessage } from '../../../../../helpers/uiFunctions/uiActions';

export class QuickBooks extends React.Component {
	constructor(props) {
		super(props);
		//console.log("construct");
		this.state = {
			qbid: {
				active: true,
				group: "quickbooks",
				instance: "all",
				key: null,
				password: null,
				platform: "quickbooks",
				secret: null,
				siteCode: "all",
				url: null,
				username: null,
				type: "qbid",
			},
		}
		this.save = this.save.bind(this);
	}

	componentDidMount(){
		if (this.props.clientCode && (this.props.clientCode !== this.state.clientCode)) {
			this.getQBinfo(this.props.clientCode);
		}
	}

	getQBinfo(id) {
		//console.log("get info");
		fetch(API_URLS.API + this.props.clientCode + "/credential/type/qbid", basicGET(localStorage.getItem("token")) )
		.then(response => {
			if (response.ok) { return response.json(); } else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			// console.log(data);
			if (data.success === true) {
				this.setState({qbid: data.result[0]});
			} else {
				var updateState = this.state.qbid;
				updateState["clientCode"] = this.props.clientCode;

				this.setState({ qbid: updateState });
			}
		})
		.catch(error => console.log(error));
	}
	save() {
		var updateState = this.state.qbid;
		var newAccountId = document.querySelector('#billing-inputs input[name="accountId"]').value;
		updateState.accountId = newAccountId;

		showMessage("Saving Billing...");

		var saveParams = {
			headers: {
				"authorization": "Bearer " + localStorage.getItem("token"),
				"Content-Type": "application/json",
			},
			body: JSON.stringify(updateState),
			method: "POST",
		}
		fetch(API_URLS.credCreate, saveParams)
		.then(response => {
			if (response.ok) { return response.json(); } 
			else { throw new Error('Something went wrong ...'); }
		})
		.then(data => {
			console.log(data);
			if (data.success === true) {
				this.setState({qbid: data.result});
				hideMessage(data.success);
			} else {
				// set an error message in the html below #billing-error
			}
		})
		.catch(error => console.log(error));
	}

	render() {
		const { qbid } = this.state;

		return (
			<React.Fragment>
				<ActionTabs
					handleSave={this.save}
					id={"billing"}
				/>
				<div id="billing-inputs" className="inputs">
					<InputRow label="QuickBooks Account ID" type="text" value={qbid.accountId} property="accountId" />
				</div>
			</React.Fragment>
		)
	}
}


// WEBPACK FOOTER //
// ./src/component_client/components/ClientProfile/ProfileComponents/Billing/QuickBooks.js